import OptionField from '../../../../forms/fields/OptionField';
import CustomerSubjectPanel from './panels/CustomerSubjectPanel';

class SubjectKindsPanels {
    constructor() {
        this._kinds = [
            {
                value: 'CUSTOMER',
                label: 'Cliente',
                Panel: CustomerSubjectPanel,
                buildFields: ({customerOptions, initialValues = {}}) => ({
                    customerId: new OptionField(customerOptions, false, undefined, initialValues.customerId),
                }),
            },
        ];
    }

    options() {
        return this._kinds.map(kind => ({label: kind.label, value: kind.value}));
    }

    panelFor(value) {
        return this._kindWith(value)?.Panel;
    }

    buildFieldsFor(value, formOptions) {
        return this._kindWith(value)?.buildFields(formOptions);
    }

    _kindWith(value) {
        return this._kinds.find(kind => kind.value === value);
    }
}

export default SubjectKindsPanels;
